import axios from '@dap/shared-utils/http.js';

export default {
    getFacebookDict (params = {}) {
        return axios.get('/dapper/api/fb_ad/dict', { params });
    },

    // 获取详情信息 广告计划/广告组/广告
    getInfo (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.get(`/dapper/api/fb_ad/${typeMap.get(type)}/edit`, {
            params,
        });
    },

    getAutoName (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.get(`/dapper/api/fb_ad/${typeMap.get(type)}/auto_name`, {
            params,
        });
    },

    // 新增/修改 广告计划/广告组/广告
    update (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');

        return axios.post(`/dapper/api/fb_ad/${typeMap.get(type)}/add`, params);
    },

    // 层级搜索 广告计划/广告组
    searchCampaignGroup (params = {}) {
        return axios.get('/dapper/api/fb_ad/search', { params });
    },

    getTargetingSearch (params = {}) {
        return axios.get('/dapper/api/fb_ad/targeting_search', { params });
    },

    getFaceBookPage (params = {}) {
        return axios.get('/dapper/api/fb_ad/facebook_page', { params });
    },

    getInstagramAccount (params = {}) {
        return axios.get('/dapper/api/fb_ad/instagram_account', { params });
    },

    getFaceBookCreativeList (params = {}) {
        return axios.get('/dapper/api/fb_ad/creative/list', { params });
    },

    getAdGroupCheck (params = {}) {
        return axios.post('/dapper/api/fb_ad/adgroup/check', params);
    },

    upLoadVideo (params = {}) {
        return axios.post('/dapper/api/fb_ad/ad/upload_video', params);
    },

    checkVideoStatus (params = {}) {
        return axios.get('/dapper/api/fb_ad/ad/check_video_status', { params });
    },

    // 保存本次创建
    createLastData (params = {}) {
        return axios.post('/dapper/api/fb_ad/batch/create_last_batch', params);
    },

    // 获取上次创建内容
    getLastData (params = {}) {
        return axios.get('/dapper/api/fb_ad/batch/get_last_batch_detail', {
            params,
        });
    },

    creativeBtach (params) {
        return axios.post('/dapper/api/fb_ad/batch/create_batch', params);
    },

    getBatchList (params) {
        return axios.get('/dapper/api/fb_ad/batch/batch_list', { params });
    },

    getAdgroupCreativePreView (params) {
        return axios.get('/dapper/api/fb_ad/batch/adgroup_creative_preview', {
            params,
        });
    },

    getBatchCreativePreView (params = {}) {
        return axios.get('/dapper/api/fb_ad/batch/batch_creative_preview', {
            params,
        });
    },

    getBatchCommitBatch (params = {}) {
        return axios.post('/dapper/api/fb_ad/batch/commit_batch', params);
    },

    updateBatchCamp (params = {}) {
        return axios.post('/dapper/api/fb_ad/batch/update_campaign', params);
    },

    updateBatchAdGroup (params = {}) {
        return axios.post('/dapper/api/fb_ad/batch/update_adgroup', params);
    },

    getCampaignNum (params = {}) {
        return axios.get('/dapper/api/fb_ad/duplicate/max_num', { params });
    },

    getAdCopyOrPushBatchId (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.post(`/dapper/api/fb_ad/duplicate/create_batch_from_${typeMap.get(type)}`, params);
    },

    getAdCopyOrPushList (params = {}) {
        return axios.get('/dapper/api/fb_ad/duplicate/duplicate_batch_list', {
            params,
        });
    },

    getAdDetailData (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/fb_ad/duplicate/get_${typeMap.get(type)}_detail`, { params });
    },

    saveCopyOrPushData (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('campaign', 'campaign');
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.post(`/dapper/api/fb_ad/duplicate/save_${typeMap.get(type)}_detail`, params);
    },

    commitCopyOrPush (params = {}) {
        return axios.post('/dapper/api/fb_ad/duplicate/commit_duplicate_batch', params);
    },
};
